import { isNamedNode, sym } from "rdflib";
import { vcard } from "../namespaces.js";
const MAILTO_URI_SCHEME = "mailto:";
const TEl_URI_SCHEME = "tel:";
export class ContactQuery {
    constructor(store, contactNode) {
        this.store = store;
        this.contactNode = contactNode;
        this.contactDoc = contactNode.doc();
    }
    queryName() {
        return (this.store.anyValue(this.contactNode, vcard("fn"), undefined, this.contactDoc) ?? "");
    }
    queryEmails() {
        const uris = this.getValuesOf(vcard("hasEmail"));
        if (uris.length === 0) {
            return [];
        }
        return uris
            .map((uri) => {
            const valueNode = this.getValueNode(uri);
            if (isMailtoNode(valueNode)) {
                return {
                    uri,
                    value: valueNode.value.split(MAILTO_URI_SCHEME)[1],
                };
            }
        })
            .filter((value) => !!value);
    }
    queryPhoneNumbers() {
        const uris = this.getValuesOf(vcard("hasTelephone"));
        if (uris.length === 0) {
            return [];
        }
        return uris
            .map((uri) => {
            const valueNode = this.getValueNode(uri);
            if (isTelNode(valueNode)) {
                return {
                    uri,
                    value: valueNode.value.split(TEl_URI_SCHEME)[1],
                };
            }
        })
            .filter((value) => !!value);
    }
    getValuesOf(predicate) {
        return this.store
            .statementsMatching(this.contactNode, predicate, undefined, this.contactDoc)
            .map((it) => it.object.value);
    }
    getValueNode(uri) {
        return this.store.any(sym(uri), vcard("value"), undefined, this.contactDoc);
    }
}
function isMailtoNode(valueNode) {
    return (isNamedNode(valueNode) && valueNode.value.startsWith(MAILTO_URI_SCHEME));
}
function isTelNode(valueNode) {
    return isNamedNode(valueNode) && valueNode.value.startsWith(TEl_URI_SCHEME);
}
//# sourceMappingURL=ContactQuery.js.map